// UserFeedGridList.js
'use strict';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import UserFeedGridList from '../page/UserFeedGridList.jsx';

import fetchFeeds from '../action/fetchFeeds.js';
import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getMeData from '../selector/getMeData.js';
import { getFeedCategory } from '../resource/feedUtils.js';

const mapStateToProps = (
  state,
  {
    location,
    match: {
      params: { category: paramCategory },
    },
  }
) => {
  const category = getFeedCategory({
    category: paramCategory,
    search: location.search,
  });
  const selectPath = ['home', 'users', category];

  const userIds = getListData(state, selectPath, 'itemIds');
  const nextPage = getListData(state, selectPath, 'nextPage');
  const isNextPageFetching = !!getNetworkingData(
    state,
    [...selectPath, nextPage],
    'isFetching'
  );
  const isAuthed = !!getMeData(state, 'id');

  return {
    category,
    nextPage,
    isNextPageFetching,
    userIds,
    isAuthed,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
    fetchFeeds: payload => dispatch(fetchFeeds(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserFeedGridList);
